import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import ImageGalleryHolder from 'core/components/image-gallery/ImageGalaryHolder';
import { setMfproductAttachImageModal } from 'store/slice/ManufSlice';
import { useDispatch } from 'react-redux';

export default function AttachImageActionImpl(){
    const dispatch = useDispatch();
    const clickToAction = () => {
        dispatch(setMfproductAttachImageModal(false));
    }
    return (
        <>
        <ImageGalleryHolder label="Continue" clickToAction={clickToAction}/>
        </>
    )
}